import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/attendance-engine/_layout/')({
  beforeLoad: () => {
    throw redirect({ to: '/attendance-engine/attendance-structures' });
  },
});
